import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { loadFingerprintIfNeeded } from '../utils/fingerprint';
import { formatPrice } from '../data/products';
import './CartScreen.css';

export default function CartScreen() {
  const { state, increment, decrement, removeFromCart, subtotalCents } = useCart();
  const navigate = useNavigate();
  const items = Object.values(state.items);

  const handleCheckout = () => {
    void loadFingerprintIfNeeded('proceed-to-checkout');
    navigate('/checkout');
  };

  return (
    <div className="cart-container">
      <div className="cart-list">
        {items.length === 0 ? (
          <p className="cart-empty">Your cart is empty</p>
        ) : (
          items.map((item) => (
            <div key={item.product.id} className="cart-item">
              <h3 className="cart-item-title">{item.product.title}</h3>
              <div className="cart-controls">
                <button 
                  className="quantity-btn" 
                  onClick={() => decrement(item.product.id)}
                >
                  -
                </button>
                <span className="quantity">{item.quantity}</span>
                <button 
                  className="quantity-btn" 
                  onClick={() => increment(item.product.id)}
                >
                  +
                </button>
                <button 
                  className="remove-btn" 
                  onClick={() => removeFromCart(item.product.id)}
                >
                  Remove
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      <div className="cart-footer">
        <p className="cart-subtotal">Subtotal: {formatPrice(subtotalCents)}</p>
        <button
          className={`checkout-button ${items.length === 0 ? 'disabled' : ''}`}
          disabled={items.length === 0}
          onClick={handleCheckout}
        >
          Proceed to Checkout
        </button>
      </div>
    </div>
  );
}
